const COLLECTION_IDS = {
  dealersCountries: "dealers_countries",
  dealersClusters: "dealers_clusters",
  dealersCities: "dealers_cities",
  dealersDealers: "dealers_dealers",
  dealersDealership: "dealers_dealerships",
  vehiclesVehicles: "vehicles_vehicles",
  vehiclesBooking: "vehicles_booking",
  vehiclesMarketingInfo: "vehicles_marketing_info",
  vehiclesBrands: "vehicles_brands",
  vehiclesModels: "vehicles_models",
  vehiclesVersions: "vehicles_versions",
  vehiclesSpecifications: "vehicles_specifications",
  vehiclesSpecificationsValues: "vehicles_specifications_values",
  vehiclesSpecificationsGroups: "vehicles_specifications_groups",
  vehiclesOptionsGroups: "vehicles_options_groups",
  vehiclesPackages: "vehicles_packages"
};
export {
  COLLECTION_IDS
};
